import { createFileRoute } from '@tanstack/react-router';
import { UserEditForm } from '@/components/custom/user-edit-form';

// `/users/new` reuses the same form as `/users/$id/edit` so both flows
// share validation, error routing, field layout, and the eventual save
// shape. Wire-up lives in user-edit-form.tsx.
export const Route = createFileRoute('/_authenticated/users/new')({
  component: UserNewPage,
});

function UserNewPage() {
  return <UserEditForm mode="create" userId={null} />;
}
